export default ['$sce', ($sce) => (url) => $sce.trustAsResourceUrl(url)];